/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
import { GLOBAL_DATE_FORMAT } from 'constant';
import moment from 'moment';

export function SignView({ data, parent }) {
    return (
        <div className="e-sign">
            {data?.is_signed_by_therapist && (
                <div
                    className="sign-info"
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: parent === 'view' ? 'flex-start' : 'center' // adjust as needed
                    }}
                >
                    <p>Signed by</p>
                    <p>
                        <b>
                            {data?.therapist?.name || ''}, {data?.therapist?.credentials || ''}
                        </b>{' '}
                        on <b>{moment.utc(data?.therapist_sign_date).local().format(`${GLOBAL_DATE_FORMAT} hh:mm A`)}</b>
                    </p>
                </div>
            )}
            {/* {data?.is_signed_by_supervisor && (
                <div className="sign-info">
                    <p>Signed by</p>
                    <p>
                        <b>
                            {data?.signed_supervisor_emp?.name || ''}, {data?.signed_supervisor_emp?.credentials || ''}
                        </b>{' '}
                        on <b>{moment.utc(data?.supervisor_sign_date).local().format(`${GLOBAL_DATE_FORMAT} hh:mm A`)}</b>
                    </p>
                </div>
            )} */}
        </div>
    );
}
